module.exports = __webpack_public_path__ + "./images/p2.JPG?2b4047dd4f45a8eb02291d3b9f7219b3";


//////////////////
// WEBPACK FOOTER
// ./src/products/p2.JPG
// module id = 55
// module chunks = 0